import "./SignupCL.css";
import { Link, useNavigate } from "react-router-dom";
import { missingPopup } from "../../../helpers/dataHelper/missingData";
import {
  clearMultiCommunityState,
  setCurrentCommunity,
  setRefetchMultiCommunityList,
  setRefetchPage,
} from "../../../redux/multicommunity/multicommunity";
import {
  setLoading,
  setResponseLoading,
} from "../../../redux/loading/loadingSlice";
import { setUserEmail, storeUser } from "../../../redux/users/usersSlice";
import { showNotificationToast, toastify } from "../../../helpers/toast/toastify";
import { useDispatch, useSelector } from "react-redux";
import Binance from "../../../assets/images/onboardingImages/binance.svg";
import Bybit from "../../../assets/images/onboardingImages/bybit.svg";
import Discord from "../../../assets/images/onboardingImages/discord.svg";
import eye from "../../../assets/images/eye.svg";
import eyeBlock from "../../../assets/images/eye-block.svg";
import FloatingTextFiled from "../../../pages/sharedPages/CommonComponents/FloatingTextFiled/FloatingTextFiled";
import React, { useEffect, useState } from "react";
import Telegram from "../../../assets/images/onboardingImages/telegram.svg";
import useApi from "../../../helpers/apiHelper/requestHelper";
import {
  redirectToBinanceOAuth,
  redirectToBybitOAuth,
} from "../../../helpers/exchangeOAuth";
import validator from "validator";
import BubbleSvgButton from "../../sharedPages/CommonComponents/BubbleSvgButton/BubbleSvgButton";
import { socailSignUp } from "../../../redux/socialSignup/socialSignUp";
import { fetchUser } from "../../../helpers/helper";
import { useAtom } from "jotai";
import { globalAllLeaderCommunities, globalCurrentPageTitle } from "../../../store/globalstore";

const ENV = window.location.hostname.split(".")[0] === "my" ? "prod" : "dev";

const PASSWORD_RULES = {
  DIGIT: /[0-9]/,
  MIN_LENGTH: 8,
  SPECIAL: /[!@#$%^&*()_+{}[\]:;<>,.?~-]/,
  UPPERCASE: /[A-Z]/,
};

const SignupCL = () => {
  const [isSignUpPage, setIsSignUpPage] = useState(false);
  const loaders = useSelector((state) => state?.loader);

  const api = useApi();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const socialSignUp = useSelector((state) => state?.socialSignUp?.value);
  const { user } = useSelector((state) => state.user);
  const [allLeaderCommunities, setAllLeaderCommunities] = useAtom(
    globalAllLeaderCommunities
  );
  const refetchScreen = useSelector(
    (state) => state?.multiCommunity?.isRefetchFromSettingPage
  );
  const refetchList = useSelector(
    (state) => state?.multiCommunity?.isRefetchMultiCommunityList
  );
  const selectedCommunity = useSelector(
    (state) => state?.multiCommunity?.currentCommunity
  );
   const [currentPageTitle, setCurrentPageTitle] = useAtom(
      globalCurrentPageTitle
    )
  const [data, setData] = useState({
    email: "",
    password: "",
  });
  const [showPassword, setShowPassword] = useState(false);
  const [validationMessage, setValidationMessage] = useState("");

  const binanceButtonClick = () => {
    if (ENV !== "prod") {
      toastify("Binance Login Not Available on Dev", "success");
      return;
    }

    redirectToBinanceOAuth({ allowSocialLogin: true });
  };

  const byBitButtonClick = async () => {
    if (ENV !== "prod") {
      toastify("Bybit Login Not Available on Dev", "success");
      return;
    }

    redirectToBybitOAuth({ allowSocialLogin: true });
  };

  const handleLoginSuccess = (loginResponse) => {
    const { data } = loginResponse || {};
    const { user, token } = data || {};

    if (!user) return;

    dispatch(storeUser(data));
    localStorage.setItem("token", token);

    setTimeout(() => {
      dispatch(setLoading(false));
      navigate(`/${user?.role}/dashboard`);
    }, 1500);
  };

  
  const handlePasswordChange = (value) => {
    const newPassword = value;

    setData((prevState) => ({
      ...prevState,
      password: newPassword,
    }));

    if (!newPassword) {
      setValidationMessage("");
      return;
    }
   if(!isSignUpPage){
    return;
   }
    const validations = [
      {
        message: "Password must contain at least one digit",
        test: PASSWORD_RULES.DIGIT.test(newPassword),
      },
      {
        message: "Password must contain at least one special character",
        test: PASSWORD_RULES.SPECIAL.test(newPassword),
      },
      {
        message: "Password must contain at least one uppercase letter",
        test: PASSWORD_RULES.UPPERCASE.test(newPassword),
      },
      {
        message: `Password must be at least ${PASSWORD_RULES.MIN_LENGTH} characters long`,
        test: validator.isLength(newPassword, {
          min: PASSWORD_RULES.MIN_LENGTH,
        }),
      },
    ];

    const failedValidation = validations.find((v) => !v.test);
    setValidationMessage(failedValidation ? failedValidation.message : "");
  };

    const leaderCommunityList = async (user) => {
        const response = await api("get", "multiCommunity/leaderCommunityList");
        const leaderAllCommunities = response?.data || [];
        setAllLeaderCommunities(leaderAllCommunities);
        
        dispatch(setCurrentCommunity(leaderAllCommunities.find((community) => community.leader === user?.selectedCommunityId)))
        dispatch(setRefetchMultiCommunityList(false));
        dispatch(setRefetchPage(""));
      };

  const handleSignup = async () => {
    try {
      if (!data.email) return missingPopup("Email");
      if (!data.password) return missingPopup("Password");
      
     
      if (!/\S+@\S+\.\S+/.test(data.email))
        return toastify("Please enter a valid email address", "error");
      if (validationMessage) return toastify(validationMessage, "error");

      dispatch(setLoading(true));

      const response = await api(
        "post",
        `newonBoard/${isSignUpPage ? "signupLeader" : "login"}`,
        data
      );
      
      if (response?.status) {
        dispatch(clearMultiCommunityState());
        const role = response?.data.user.role;
        const loggedInUser = response?.data?.user;
        // dispatch(setLoading(true));
        if(!response?.data?.otp&&!isSignUpPage){
          if(response?.data?.todayMembersCount>0){

            showNotificationToast(`${response?.data?.todayMembersCount} new subscribers today! 🚀`, "");
          }

        localStorage.setItem("token", response?.data?.token);
        
        if(role === "leader" && loggedInUser?.selectedCommunityId){
          // dispatch(setRefetchSpecificUser(true));
          await leaderCommunityList(loggedInUser);  
          const response = await api("post", "multiCommunity/getSpecificUser", {
            id: loggedInUser?.selectedCommunityId,
          });
      
          localStorage.setItem("token", response?.data?.token);
          dispatch(storeUser(response?.data));
        }else{
          await fetchUser(api, dispatch, storeUser);
        }
        setCurrentPageTitle("Dashboard");
        }
        if(isSignUpPage){
           localStorage.setItem("token", response?.data?.token);
           dispatch(storeUser(response?.data));
          // await fetchUser(api, dispatch, storeUser);
        }
        setTimeout(async () => {
          if (response?.data?.otp && !isSignUpPage) {
            dispatch(setUserEmail(data.email))
            navigate("/login/newVerifyEmail", { replace: true });
            dispatch(setLoading(false));
            return;
          } else if (role === "memberNoLink") {
            // setTimeout(async () => {
              // if (response?.data?.otp && !isSignUpPage) {
              //   dispatch(setUserEmail(data.email))
              //   navigate("/login/newVerifyEmail", { replace: true });
              //   dispatch(setLoading(false));
              //   return;
              // } else {
                // localStorage.setItem("token", response?.data?.token);
                // await fetchUser(api, dispatch, storeUser);
                // dispatch(setLoading(false));
                navigate(`/cmWithNoLink/dashboard`, { replace: true });
                return;
              // }
            // }, 1500);
          }else{
            navigate(`/${role}/dashboard`, { replace: true });
            return;
          }
        }, 1500);
      } else {
        setTimeout(() => {
          dispatch(setLoading(false));
          toastify(response?.message);
        }, 1500);
      }
    } catch (error) {
      console.error("🚀 -> handleSignup -> error:", error);
    }
  };

  const loginWithDiscord = async () => {
    const discordOAuthURL = process.env.REACT_APP_DISCORD_OAUTH_URL;
    window.location.href = discordOAuthURL;
  };

  const telegramRedirectUrl = () => {
    dispatch(
      socailSignUp({
        community: null,
      })
    );

    const telegramOAuthURL = process.env.REACT_APP_TELEGRAM_OAUTH_URL;
    window.location.href = telegramOAuthURL;
  };

  const loginWithTelegram = async (data) => {
    dispatch(setLoading(true));

    const response = await api("post", "fastSignupLogin/Telegram", {
      telegramRes: data,
      community: socialSignUp?.community,
    });

    if (response?.status) handleLoginSuccess(response);
  };

  useEffect(() => {
    const handleTelegramAuth = () => {
      const hash = window.location.hash;

      if (!hash || !hash.includes("tgAuthResult=")) return;
      dispatch(setLoading(true));

      try {
        const base64Data = hash.split("tgAuthResult=")[1];
        const decodedData = decodeURIComponent(atob(base64Data));
        const telegramData = JSON.parse(decodedData);

        loginWithTelegram(telegramData);
        window.history.replaceState(null, null, window.location.pathname);
      } catch (error) {
        console.error("🚀 -> handleTelegramAuth -> error:", error);
      }
    };

    handleTelegramAuth();
  }, []);

  useEffect(() => {
    if (new URLSearchParams(window.location.search).has("code")) return;

    localStorage.removeItem("AllowSocialLogin");
    dispatch(setLoading(false));
    dispatch(setResponseLoading(false));
  }, []);
  
  return (
    <div className="onboardinLayout">
      <div className="onboardingCard">
        <div className="onboardingCardTopBox">
          <p
            className="loginTopLeft"
            onClick={() => {
              navigate(`/cmWithNoLink/login`);
            }}
          >
            {"No Link Member"}
          </p>
          <p
            className="loginTop"
            onClick={() => {
              setIsSignUpPage((prevState) => !prevState);
              setData({
                email: "",
                password: "",
              });
            }}
          >
            {isSignUpPage ? "Log In" : "Sign up"}
          </p>
        </div>
        <div className="onboardingCardContentBox">
          <div className="headingBox withHeight">
            <h2 className="title">{`${
              isSignUpPage ? "Create an account" : "Log in"
            }`}</h2>
            <p className="subText">
              {`${
                isSignUpPage
                  ? "Submit email and a strong password"
                  : "Sign in to access your account"
              }`}
            </p>
          </div>
          <div className="inputBox">
            <FloatingTextFiled
              className={`onboardingInput loginSignUpInput ${data.email ? "filled" : ""}`}
              forLabel="Email"
              label="Email"
              onChange={(e) =>
                setData((pre) => ({ ...pre, email: e.target.value }))
              }
              placeholder="Email"
              type="email"
              value={data.email}
            />
          </div>
          <div className="inputBox password">
            <FloatingTextFiled
              className={`onboardingInput loginSignUpInput ${data.password ? "filled" : ""}`}
              forLabel="Password"
              label="Password"
              onChange={(e) => {
                handlePasswordChange(e.target.value);
              }}
              placeholder="Password"
              type={showPassword ? "text" : "Password"}
              value={data.password}
            />
            <button
              className={`eyebtn ${showPassword && "view"}`}
              onClick={() => {
                setShowPassword((pre) => !pre);
              }}
              type="button"
            >
              <img style={{marginBottom:`${!isSignUpPage ? "26px" : "0px"}`}} alt="" src={showPassword ? eye : eyeBlock} />
            </button>
            <div style={{textAlign:"right"}}>

           {!isSignUpPage && <p
            className="forgetPassLink"
            style={{display:"inline-block"}}
            onClick={() => {
              navigate(`/login/forgotPassword`);
            }}
            >
            {"Forgot Password"}
          </p>}
            </div>
          </div>
          <BubbleSvgButton
            onClick={handleSignup}
            text={`${isSignUpPage ? "Sign up with email" : "Log in"}`}
            type="button"
            variant="green"
            containerStyling={{
              justifyContent: "center",
            }}
          />
          {/* in-progress */}
          {/* <div className="orBox">
            {isSignUpPage ? (
              <>
                <p className="orText">Or sign up faster</p>
              </>
            ) : (
              <>
                <p className="orText noBorder">
                  Or did you sign up with a social account?
                </p>
              </>
            )}
          </div>
          <div className="fasterLoginBox">
            <button
              className="fasterLoginBtn"
              onClick={telegramRedirectUrl}
              type="button"
            >
              <img alt="" src={Telegram} />
            </button>

            <button
              className="fasterLoginBtn"
              onClick={loginWithDiscord}
              type="button"
            >
              <img alt="" src={Discord} />
            </button>

            <button
              className="fasterLoginBtn"
              onClick={binanceButtonClick}
              type="button"
            >
              <img alt="" src={Binance} />
            </button>

            <button
              className="fasterLoginBtn"
              onClick={byBitButtonClick}
              type="button"
            >
              <img alt="" src={Bybit} />
            </button>
          </div> */}
          {isSignUpPage && (
            <div className="privacyContentBox">
              <p>
                By continuing, you agree to accept our <br />
                <Link to="http://copyyy.it/privacy-policies">
                  Privacy Policy
                </Link>{" "}
                &{" "}
                <Link to="http://copyyy.it/terms-and-conditions">
                  Terms of Service
                </Link>
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SignupCL;
